import service from '@/utils/request'

export const getCustomerResourceList = (data) => {
  return service({ url: "/admin/trunk/getCustomerResourceList", method: 'post', data })
}

export const createCustomerResource = (data) => {
  return service({ url: "/admin/trunk/createCustomerResource", method: 'post', data })
}

export const updateCustomerResource = (data) => {
  return service({ url: "/admin/trunk/updateCustomerResource", method: 'post', data })
}

export const deleteCustomerResource = (data) => {
  return service({ url: "/admin/trunk/deleteCustomerResource", method: 'post', data })
}

export const exportCustomerResource = (data) => {
  return service({ url: "/admin/trunk/exportCustomerResource", method: 'post', data, responseType: 'blob' })
}
